// src/constants/google.js

const google = {
    SCOPE: 'openid email profile https://www.googleapis.com/auth/drive',
    UX_MODE: 'redirect',
    FOLDER_MIME: 'application/vnd.google-apps.folder',
    SHORTCUT_MIME: 'application/vnd.google-apps.shortcut',
    S_SRC: 'https://accounts.google.com/gsi/client',

    IMAGE_EXT: [".jpg", ".jpeg", ".png", ".webp", ".gif", ".bmp", ".tiff", ".svg"],
    VIDEO_EXT: [".mp4", ".webm", ".ogg", ".mov", ".m4v", ".avi", ".mkv"],
    CACHE_TTL_MS: 60_000,
};

export default google;

